(() => {
  angular.module('pims').filter('format', () => {
    return (string, type) => {
      switch (type) {
        case 'kebab':
          return _.kebabCase(string);

        case 'snake':
          return _.snakeCase(string);

        case 'space':
          return string.replace(/(_|-)/g, ' ');

        default:
          return string;
      }
    };
  });
})();